import { HttpErrorResponse } from '@angular/common/http';
import { RetryConfig } from '@vendasta/rx-utils';

const serverErrorChecker = (err: HttpErrorResponse) => err.status && (err.status >= 500 || err.status === 403);
const serverError500Checker = (err: HttpErrorResponse) => err.status && err.status >= 500;

// Don't use on mutation calls
export const getCallRetryConfig: RetryConfig = {
  maxAttempts: 5,
  retryDelay: 250,
  timeoutMilliseconds: 10000,
  customRetryChecker: serverErrorChecker,
};

export const meetingSchedulerInitializationRetryConfig: RetryConfig = {
  maxAttempts: 5,
  retryDelay: 500,
  timeoutMilliseconds: 10000,
  customRetryChecker: serverErrorChecker,
};

export const meetingSchedulerCreateDefaultMeetingTypesRetryConfig: RetryConfig = {
  maxAttempts: 5,
  retryDelay: 250,
  timeoutMilliseconds: 10000,
  customRetryChecker: serverError500Checker,
};
